import React from 'react'

import { Container, ContentHeader } from 'components'
import {
  IntegrationTokenEdit,
  PaymentMethodsEdit as PaymentMethodsEditBox,
  ConfigurationEdit,
} from './components'

const PaymentMethodsEdit = () => {
  return (
    <Container>
      <ContentHeader title="Meios de pagamento" subtitle="Editar" />

      <IntegrationTokenEdit />

      <PaymentMethodsEditBox />

      <ConfigurationEdit />
    </Container>
  )
}

export default PaymentMethodsEdit
